import { render } from "./CustomRoads.htm?vue&type=template&id=81245ce0&scoped=true&ts=true"
import script from "./CustomRoads.vue?vue&type=script&lang=ts"
export * from "./CustomRoads.vue?vue&type=script&lang=ts"

import "./CustomRoads.scss?vue&type=style&index=0&id=81245ce0&lang=scss&scoped=true"

import exportComponent from "C:\\Projets\\FIFA\\Dev\\GIS-Dispatcher-Front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81245ce0"]])

export default __exports__